import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-gutter md:mx-auto max-w-750" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpandHeightToggle = _resolveComponent("ExpandHeightToggle")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (_ctx.content.subheading)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "o-text-caption uppercase m-0",
          innerHTML: _ctx.content.subheading
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.content.title)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 1,
          class: "mb-10",
          innerHTML: _ctx.content.title
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.showReadMoreToggle)
      ? (_openBlock(), _createBlock(_component_ExpandHeightToggle, {
          key: 2,
          "text-list": _ctx.content.seoTexts
        }, null, 8, ["text-list"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "my-10 magic-line-on-child-links",
          innerHTML: _ctx.content.text
        }, null, 8, _hoisted_4)),
    (_ctx.content.link)
      ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
          key: 4,
          "link-block": _ctx.content.link,
          "style-as-button": true,
          class: "mt-25"
        }, null, 8, ["link-block"]))
      : _createCommentVNode("", true)
  ]))
}